import React, { PropsWithChildren } from "react"
import { ErrorBoundary } from "./ErrorBoundary"
import { ErrorBox } from "./ErrorBox"

type ButterCmsErrorBoundaryProps = PropsWithChildren<{
  componentName: string
}>

// Because the schema comes from butter cms and may be change in the future, encapsulate all the first-level components
// inside an ErrorBoundary to prevent the frontend to crash if a page schema changes
export const ButterCmsErrorBoundary = (props: ButterCmsErrorBoundaryProps) => {
  const { componentName, children } = props

  return (
    <ErrorBoundary
      fallback={(error) => (
        <ErrorBox>
          There was an error inside <b>{componentName}</b> component: {error?.toString()} <br />
        </ErrorBox>
      )}
    >
      {children}
    </ErrorBoundary>
  )
}
